
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SupportMenu',
  props: {
    isCollapsed: Boolean
  }
})
